var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_1799",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 25,
    height: 26
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.5552 17.0673C26.6558 10.3169 22.2732 3.919 15.7666 2.77725C9.25998 1.63551 3.09317 6.18223 1.99266 12.9326C0.892143 19.6831 5.27466 26.0809 11.7813 27.2227C18.2879 28.3644 24.4547 23.8177 25.5552 17.0673Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_1799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.6656 2.42761H-6.14545V31.7194H36.6656V2.42761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.9873 2.42761H-6.14545V15.8218H13.9873V2.42761Z",
    fill: "#455497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.6656 2.42761H13.9873V4.92236H36.6656V2.42761Z",
    fill: "#A71C2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.6656 7.87302H13.9873V10.3678H36.6656V7.87302Z",
    fill: "#A71C2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M36.6656 13.3271H13.9873V15.8218H36.6656V13.3271Z",
    fill: "#A71C2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M36.6656 18.7725H-6.14545V21.2673H36.6656V18.7725Z",
    fill: "#A71C2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M36.6656 23.9943H-6.14545V26.489H36.6656V23.9943Z",
    fill: "#A71C2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M3.2161 4.66431L3.36535 4.974L3.70532 5.02561L3.45656 5.26649L3.51461 5.61059L3.2161 5.45574L2.91759 5.61059L2.97563 5.26649L2.73517 5.02561L3.06684 4.974L3.2161 4.66431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M7.54453 4.66431L7.69378 4.974L8.02546 5.02561L7.78499 5.26649L7.84304 5.61059L7.54453 5.45574L7.24602 5.61059L7.30406 5.26649L7.0636 5.02561L7.39527 4.974L7.54453 4.66431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M11.4085 4.66431L11.5577 4.974L11.8894 5.02561L11.6489 5.26649L11.707 5.61059L11.4085 5.45574L11.11 5.61059L11.168 5.26649L10.9276 5.02561L11.2592 4.974L11.4085 4.66431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M5.33054 3.62335L5.47979 3.94165L5.81147 3.98466L5.571 4.23413L5.62905 4.57824L5.33054 4.41479L5.03203 4.57824L5.09007 4.23413L4.84961 3.98466L5.18128 3.94165L5.33054 3.62335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M9.35215 3.62335L9.5014 3.94165L9.83308 3.98466L9.59261 4.23413L9.65065 4.57824L9.35215 4.41479L9.05364 4.57824L9.11168 4.23413L8.87122 3.98466L9.20289 3.94165L9.35215 3.62335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M12.8596 3.62335L13.0088 3.94165L13.3405 3.98466L13.1 4.23413L13.1581 4.57824L12.8596 4.41479L12.5611 4.57824L12.6191 4.23413L12.3704 3.98466L12.7103 3.94165L12.8596 3.62335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M3.2161 6.65149L3.36535 6.96978L3.70532 7.0128L3.45656 7.26227L3.51461 7.60638L3.2161 7.44293L2.91759 7.60638L2.97563 7.26227L2.73517 7.0128L3.06684 6.96978L3.2161 6.65149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M7.54453 6.65149L7.69378 6.96978L8.02546 7.0128L7.78499 7.26227L7.84304 7.60638L7.54453 7.44293L7.24602 7.60638L7.30406 7.26227L7.0636 7.0128L7.39527 6.96978L7.54453 6.65149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M11.4085 6.65149L11.5577 6.96978L11.8894 7.0128L11.6489 7.26227L11.707 7.60638L11.4085 7.44293L11.11 7.60638L11.168 7.26227L10.9276 7.0128L11.2592 6.96978L11.4085 6.65149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M5.33054 5.61057L5.47979 5.92886L5.81147 5.98048L5.571 6.22135L5.62905 6.56545L5.33054 6.402L5.03203 6.56545L5.09007 6.22135L4.84961 5.98048L5.18128 5.92886L5.33054 5.61057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M9.35215 5.61057L9.5014 5.92886L9.83308 5.98048L9.59261 6.22135L9.65065 6.56545L9.35215 6.402L9.05364 6.56545L9.11168 6.22135L8.87122 5.98048L9.20289 5.92886L9.35215 5.61057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M12.8596 5.61057L13.0088 5.92886L13.3405 5.98048L13.1 6.22135L13.1581 6.56545L12.8596 6.402L12.5611 6.56545L12.6191 6.22135L12.3704 5.98048L12.7103 5.92886L12.8596 5.61057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M3.2161 8.97415L3.36535 9.29245L3.70532 9.33546L3.45656 9.58493L3.51461 9.92904L3.2161 9.76559L2.91759 9.92904L2.97563 9.58493L2.73517 9.33546L3.06684 9.29245L3.2161 8.97415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M7.54453 8.97415L7.69378 9.29245L8.02546 9.33546L7.78499 9.58493L7.84304 9.92904L7.54453 9.76559L7.24602 9.92904L7.30406 9.58493L7.0636 9.33546L7.39527 9.29245L7.54453 8.97415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M11.4085 8.97415L11.5577 9.29245L11.8894 9.33546L11.6489 9.58493L11.707 9.92904L11.4085 9.76559L11.11 9.92904L11.168 9.58493L10.9276 9.33546L11.2592 9.29245L11.4085 8.97415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M5.33054 7.94186L5.47979 8.25156L5.81147 8.30317L5.571 8.54404L5.62905 8.88815L5.33054 8.7247L5.03203 8.88815L5.09007 8.54404L4.84961 8.30317L5.18128 8.25156L5.33054 7.94186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M9.35215 7.94186L9.5014 8.25156L9.83308 8.30317L9.59261 8.54404L9.65065 8.88815L9.35215 8.7247L9.05364 8.88815L9.11168 8.54404L8.87122 8.30317L9.20289 8.25156L9.35215 7.94186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M12.8596 7.94186L13.0088 8.25156L13.3405 8.30317L13.1 8.54404L13.1581 8.88815L12.8596 8.7247L12.5611 8.88815L12.6191 8.54404L12.3704 8.30317L12.7103 8.25156L12.8596 7.94186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M3.2161 11.3399L3.36535 11.6582L3.70532 11.7098L3.45656 11.9507L3.51461 12.2948L3.2161 12.1313L2.91759 12.2948L2.97563 11.9507L2.73517 11.7098L3.06684 11.6582L3.2161 11.3399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M7.54453 11.3399L7.69378 11.6582L8.02546 11.7098L7.78499 11.9507L7.84304 12.2948L7.54453 12.1313L7.24602 12.2948L7.30406 11.9507L7.0636 11.7098L7.39527 11.6582L7.54453 11.3399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M11.4085 11.3399L11.5577 11.6582L11.8894 11.7098L11.6489 11.9507L11.707 12.2948L11.4085 12.1313L11.11 12.2948L11.168 11.9507L10.9276 11.7098L11.2592 11.6582L11.4085 11.3399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M5.33054 10.3076L5.47979 10.6172L5.81147 10.6689L5.571 10.9183L5.62905 11.2624L5.33054 11.099L5.03203 11.2624L5.09007 10.9183L4.84961 10.6689L5.18128 10.6172L5.33054 10.3076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M9.35215 10.3076L9.5014 10.6172L9.83308 10.6689L9.59261 10.9183L9.65065 11.2624L9.35215 11.099L9.05364 11.2624L9.11168 10.9183L8.87122 10.6689L9.20289 10.6172L9.35215 10.3076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M12.8596 10.3076L13.0088 10.6172L13.3405 10.6689L13.1 10.9183L13.1581 11.2624L12.8596 11.099L12.5611 11.2624L12.6191 10.9183L12.3704 10.6689L12.7103 10.6172L12.8596 10.3076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M3.2161 13.6282L3.36535 13.9379L3.70532 13.9895L3.45656 14.2304L3.51461 14.5745L3.2161 14.411L2.91759 14.5745L2.97563 14.2304L2.73517 13.9895L3.06684 13.9379L3.2161 13.6282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M7.54453 13.6282L7.69378 13.9379L8.02546 13.9895L7.78499 14.2304L7.84304 14.5745L7.54453 14.411L7.24602 14.5745L7.30406 14.2304L7.0636 13.9895L7.39527 13.9379L7.54453 13.6282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M11.4085 13.6282L11.5577 13.9379L11.8894 13.9895L11.6489 14.2304L11.707 14.5745L11.4085 14.411L11.11 14.5745L11.168 14.2304L10.9276 13.9895L11.2592 13.9379L11.4085 13.6282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M5.33054 12.5872L5.47979 12.9055L5.81147 12.9486L5.571 13.198L5.62905 13.5421L5.33054 13.3787L5.03203 13.5421L5.09007 13.198L4.84961 12.9486L5.18128 12.9055L5.33054 12.5872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M9.35215 12.5872L9.5014 12.9055L9.83308 12.9486L9.59261 13.198L9.65065 13.5421L9.35215 13.3787L9.05364 13.5421L9.11168 13.198L8.87122 12.9486L9.20289 12.9055L9.35215 12.5872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M12.8596 12.5872L13.0088 12.9055L13.3405 12.9486L13.1 13.198L13.1581 13.5421L12.8596 13.3787L12.5611 13.5421L12.6191 13.198L12.3704 12.9486L12.7103 12.9055L12.8596 12.5872Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.d809a69c09b1684da4c397e5fc202b23.svg";
export { ForwardRef as ReactComponent };